export const css = {
    rootFixed: '_6Y2g_NDS',
    titleFixed: '_2UcqczLM',
    titleButtonFixed: '-UOnGTxy',
    contentFixed: 's6saIizZ',
    closeableFixed: '_2uBWX2CW',
    ' _key': 'base-widgets/title-pane-fixed'
};
export default css;
